<app-header (notifyMobileOpen)="getMobileOpenNotification($event)"></app-header>
<div class="mainContainer">
    <app-menu selectedItem="vertraege" class="menu" [class.open]="mobileMenuOpen"></app-menu>

    <div class="content" [class.closed]="mobileMenuOpen">
        @if (vertragName() && !task()) {
            <div class="gridContainer">
                @if (showAuslastungWarnung()) {
                    <div class="message">
                        <div class="ic"><i class="icon ico-warning"></i></div>
                        <div class="txt">Dieser Rahmenvertrag ist über {{ currVertrag().rahmenBelastung | calcPercent: currVertrag().rahmenBetrag }} des Kreditrahmens ausgeschöpft.</div>
                        <div class="options">
                            <button (click)="vertragAendern()" class="btn-orange-white">Jetzt direkt erhöhen</button>
                        </div>
                    </div>
                }
                <h1 class="goBack" (click)="goBack()">
                    {{ currVertrag().vertragsart }} {{ currVertrag().vertragHandle.vsnrFormatiert }}
                </h1>
                <h2>
                    Vertragsdaten im Detail
                    <div class="options" (click)="vertragAendern()">
                        <button class="btn-white-orange">
                            <span class="btn-ico-aenderung"></span> <span class="btn-text">Änderung beantragen</span>
                        </button>
                    </div>
                </h2>
                <div class="gridContainer dataGrid">
                    <div class="row">
                        <div class="cell grid-33">
                            <span class="label">Versicherungsscheinnummer</span>
                            <span class="value">{{ currVertrag().vertragHandle.vsnrFormatiert }}</span>
                        </div>
                        <div class="cell grid-33">
                            <span class="label">Produkt</span>
                            <span class="value">{{ currVertrag().vertragsart }}</span>
                        </div>
                        <div class="cell grid-33">
                            @if (currVertrag().modul && currVertrag().modul.length !== 0) {
                                <div>
                                    <span class="label">Produktlinie</span>
                                    <span class="value">{{ currVertrag().modul }}</span>
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row">
                        <div class="cell grid-33">
                            <span class="label">Beitrag jährlich</span>
                            <span class="value">{{ currVertrag().grundversorgungsbeitrag | formatMoney }}</span>
                        </div>
                        <div class="cell grid-66">
                            <span class="label">Geschäftsjahr</span>
                            <span class="value">{{ currVertrag().geschaeftsjahr }}</span>
                        </div>
                    </div>
                </div>

                <h2>Rahmenbelastung</h2>
                    <div class="gridContainer dataGrid">
                        <div class="row">
                            <div class="cell grid-25">
                                <span class="label">Höhe der Kreditlinie</span>
                                <span class="value">{{ currVertrag().rahmenBetrag | formatMoney }}</span>
                            </div>
                            <div class="cell grid-25">
                                <span class="label">Aktuelle Auslastung</span>
                                <span class="value">{{ currVertrag().rahmenBelastung | formatMoney }}</span>
                            </div>
                            <div class="cell grid-25">
                                <span class="label">Höchstbetrag je Bürgschaft</span>
                                @if (currVertrag().buergscheinLimit) {
                                    <div>
                                        <span class="value">{{ currVertrag().buergscheinLimit | formatMoney }}</span>
                                    </div>
                                }
                                @if (!currVertrag().buergscheinLimit && currVertrag().sollStreuquote) {
                                    <div>
                                        <span class="value">{{ currVertrag().sollStreuquote | formatPercent }}</span>
                                    </div>
                                }
                                @if (!currVertrag().buergscheinLimit && !currVertrag().sollStreuquote) {
                                    <div>
                                        <span class="value">-</span>
                                </div>
                            }
                        </div>
                        <div class="cell grid-25">
                            <span class="label">Aktuelle Auslastung Sublimit</span>
                            <span class="value">{{ currVertrag().auslastungSublimit | formatMoney }}</span>
                        </div>
                    </div>
                    @if (currVertrag().rahmenBetrag) {
                        <div class="row">
                            <div class="cell grid-100">
                                <div class="outerPercent">
                                    <div class="innerPercent" [style.width]="currVertrag().rahmenBelastung | calcPercent: currVertrag().rahmenBetrag"></div>
                                    <div class="innerPercentFont">
                                        <span class="hinweis hinweis-text">Sie nutzen aktuell {{ currVertrag().rahmenBelastung | calcPercent: currVertrag().rahmenBetrag }} Ihres Bürgschaftsrahmens</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
                <!--  Third line -->
                <h2>
                    Bürgschaften
                    <div class="options">
                        <button class="btn-white-orange" (click)="goToObligoAction()">
                            <span class="btn-ico-liste"></span> <span class="btn-text">Obligoliste anfordern</span>
                        </button>
                    </div>
                </h2>
                @if (visibleBuergscheine()) {
                    <pagination
                        [numItems]="visibleBuergscheine().length"
                        [current]="currentOffset()"
                        (goToPageEvent)="pagerAction($event)"></pagination>
                }
                <elem-table [tableData]="visibleBuergscheine()"
                            [tableMeta]="buergscheinMetaData"
                            [actionFn]="goToBuergscheinAction"
                            [targetParam]="buergscheinTargetParam"
                            [searchAction]="searchBuergschein"
                            [currentOffset]="currentOffset()"
                            [detailsClass]="'openDetails'"
                            [lineHasChild]="true"
                            (goToPageEvent)="pagerAction($event)">
                </elem-table>
                @if (visibleBuergscheine()) {
                    <pagination
                        [numItems]="visibleBuergscheine.length"
                        [current]="currentOffset()"
                        (goToPageEvent)="pagerAction($event)"></pagination>
                }
            </div>
        }

        <!--  -->
        <!-- End single. Begin survey. -->
        <!--  -->
        @if (!vertragName() && !task()) {
            <div>
                <h1>
                    Kautionsverträge
                    <div class="options">
                        <a class="button btn-white-orange" href="{{ urlNeuenVertragAbschliessen() }}" target="_blank" rel="noopener noreferrer">
                            <span class="btn-ico-neu"></span> <span class="btn-text">Vertrag hinzufügen</span>
                        </a>
                    </div>
                </h1>
                @if (vertraegeList() && vertraegeList().length > 0) {
                    @for (vertragData of vertraegeList(); track vertragData; let i = $index) {
                        <elem-vertrag-short
                            [vertrag]="vertragData"
                            [odd]="i%2 === 0"></elem-vertrag-short>
                    }
                } @else {
                    <p>Es wurden keine Verträge gefunden.</p>
                }
            </div>
        }
        @if (task() === 'erhoehen') {
            <vertrag-aendern>
                Erhöhen.
            </vertrag-aendern>
        }

    </div>
</div>
